export default function () {
  this.existsRegister('/v1/professional/steps/agendas/status', (data, meta) => {
    if (!data.addresses) {
      this.statusAddress = data.addresses
      this.show = true
    }
    this.statusAddress = data.addresses
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/resources/mounted.js